exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chat_envelope__unread[data-v-f86a0c30]{font-weight:700}.chat_envelope__pointer[data-v-f86a0c30]{cursor:pointer}.chat_envelope__pulse[data-v-f86a0c30]{width:44px;height:44px;animation:chat_envelope_animscale-data-v-f86a0c30 .3s ease-in-out alternate}.chat__envelope-attendee[data-v-f86a0c30]{margin-bottom:2px}.chat_notifications_label[data-v-f86a0c30]{font-size:14px;line-height:25px;margin-right:1rem}.chat_envelope__hide_list[data-v-f86a0c30]{display:none}@keyframes chat_envelope_animscale-data-v-f86a0c30{0%{transform:scale(1)}to{transform:scale(1.2)}}", ""]);

// exports
